import GetSecureEntryKeyboardType from './types';

/**
 * Return keyboardType passed as function parameter on Web/Desktop/iOS
 */
const getSecureEntryKeyboardType: GetSecureEntryKeyboardType = (keyboardType) => keyboardType;

export default getSecureEntryKeyboardType;
